import { controller } from './controller';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLVideoElement {
        fastBackward(): void;
        fastForward(): void;
        stepBackward(fps?: number): void;
        stepForward(fps?: number): void;
        stop(): void;
    }
}

// ----------------------------------------------------------------------------

HTMLVideoElement.prototype.stop = function (): void {
    controller.stop(this);
};

HTMLVideoElement.prototype.fastBackward = function (): void {
    controller.fastBackward(this);
};

HTMLVideoElement.prototype.fastForward = function (): void {
    controller.fastForward(this);
};

HTMLVideoElement.prototype.stepBackward = function (fps?: number): void {
    controller.stepBackward(this, fps);
};

HTMLVideoElement.prototype.stepForward = function (fps?: number): void {
    controller.stepForward(this, fps);
};
